<template>
  <content-dashboard :hide="true">
    <filtro-Multas @input="loadFiltro($event)" />
    <tabela-Multas
      :key="tabela"
      :multas="multas"
      :loading="loading"
      :loaded="loaded"
      @input="loadData($event)"
    >
    </tabela-Multas>
  </content-dashboard>
</template>

<script>
import tabelaMultas from "./TabelaMultas";
import filtroMultas from "./FiltroMultas";
import queryString from "querystring";
import urlApi from "@/routes/urlApi";
import { mapState } from "vuex";
import { showError } from "@/global";

export default {
  components: {
    tabelaMultas,
    filtroMultas,
    Alert: () => import("./Alert")
  },
  data() {
    return {
      overlay: false,
      filtro: {},
      multas : [],
      showAlert: false,
      loading : false,
      loaded : false,
      tabela: 1,
    }
  },
  methods: {
    loadFiltro(filtro) {
      this.filtro = filtro;
      this.loadData();
    },
    verificarObjetoVazio(objeto) {
      return Object.keys(objeto).length === 0 && objeto.constructor === Object
        ? ""
        : `${queryString.stringify(objeto)}`;
    },
    loadData(page = 1) {
      this.$store.commit("overlay/toggle", true);
      this.loading = true;
      const filtro = this.verificarObjetoVazio(this.filtro);

      const url = `${urlApi}/endpoint/pagamentos-abertos?${filtro}&page=${page}`
      this.$http
        .get(url)
        .then((res) => {
          let convertFloat = res.data.dados.autos.map(el=>{ el.valor_infracao = Intl.NumberFormat('de-DE').format(el.valor_infracao);return el});
          this.multas = convertFloat;
          this.$store.commit("overlay/toggle", false);
          this.loading = false;
        })
        .catch(( e ) => {
          showError(e);
          this.loading = false;
          this.$store.commit("overlay/toggle", false);
        });
    },
  },

  created() {
    this.loadData();
  },

  computed: {
    ...mapState("user", ["permissoes", "user"]),
  },
};
</script>
